import React, { Children, cloneElement } from 'react';

import { ComponentProps } from '../utils/types';
import { StyledTimeline } from './styles';
import TimelineSkeleton from './TimelineSkeleton';
import TimelinePropsInterface from './types';

const Timeline = React.forwardRef<HTMLOListElement, TimelinePropsInterface>(
  ({ children, loading = false, ...rest }, ref) => {
    return (
      <StyledTimeline {...rest} ref={ref}>
        {loading ? (
          <TimelineSkeleton>{children}</TimelineSkeleton>
        ) : (
          Children.map(children, (child, index) => {
            if (!React.isValidElement(child)) return null;
            return cloneElement(child, {
              order: index
            });
          })
        )}
      </StyledTimeline>
    );
  }
);

export type TimelineProps = ComponentProps<typeof Timeline>;
export default Timeline;
